import React, { useEffect, useState } from "react";
import QRCode from "qrcode.react";
import openSocket from "../../services/socket-io";
import toastError from "../../errors/toastError";

import { Dialog, DialogContent, makeStyles, Paper, Typography } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";

const useStyles = makeStyles(() => ({
	content: {
		textAlign: "center",
		padding: "35px 20px",
	},
	paper: {
		display: "flex",
		alignItems: "center",
		flexDirection: "column",
	},
	qrCode: {
		display: "block",
		marginLeft: "auto",
		marginRight: "auto",
	},
}));

const QrcodeModal = ({ open, onClose, whatsAppId }) => {
	const classes = useStyles();
	const [qrCode, setQrCode] = useState("");

	useEffect(() => {
		const fetchSession = async () => {
			if (!whatsAppId) return;

			try {
				const { data } = await api.get(`/connections/${whatsAppId}`);
				setQrCode(data.qrcode);
			} catch (err) {
				toastError(err);
			}
		};
		fetchSession();
	}, [whatsAppId]);

	useEffect(() => {
		if (!whatsAppId) return;
		const socket = openSocket();

		socket.on("connectionSession", data => {
			if (data.action !== "update" || data.session.id !== whatsAppId) return;

			setQrCode(data.session.qrcode);

			if (data.session.qrcode === "") {
				onClose();
			}
		});

		socket.on("freeTrialPhoneBlocked", data => {
			if (data.connectionId !== whatsAppId) return;
			onClose();
		});

		return () => {
			socket.disconnect();
		};
	}, [whatsAppId, onClose]);

	return (
		<Dialog open={open} onClose={onClose} maxWidth="lg" scroll="paper">
			<DialogContent className={classes.content}>
				<Paper elevation={0} className={classes.paper}>
					<Typography color="primary" gutterBottom>
						{i18n.t("qrCode.message")}
					</Typography>
					{qrCode ? (
						<QRCode value={qrCode} size={256} className={classes.qrCode} />
					) : (
						<span>Waiting for QR Code</span>
					)}
				</Paper>
			</DialogContent>
		</Dialog>
	);
};

export default React.memo(QrcodeModal);

